import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";

interface NewsCardProps {
  item: NewsItem;
  horizontal?: boolean;
}

export default function NewsCard({ item, horizontal = false }: NewsCardProps) {
  if (horizontal) {
    return (
      <Link
        to={`/detail/${item.streamerId}`}
        className="group flex gap-4 p-3 rounded-lg bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors"
      >
        <div className="w-28 h-20 md:w-36 md:h-24 shrink-0 rounded-md overflow-hidden bg-background-100">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} 韩国女主播资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex flex-col flex-1 min-w-0">
          <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1.5">
            <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-600 font-medium">{item.category}</span>
            <span>{item.date}</span>
          </div>
          <h3 className="text-sm md:text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
            {item.title}
          </h3>
          <p className="hidden sm:block text-xs text-foreground-500 leading-relaxed line-clamp-2 mt-1.5">
            {item.summary}
          </p>
          <span className="text-xs text-foreground-400 mt-auto pt-1.5">
            <i className="ri-user-star-line mr-0.5"></i>
            {item.streamerName}
          </span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${item.streamerId}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-accent-300 transition-colors h-full"
    >
      <div className="w-full aspect-video overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 韩国女主播资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-col flex-1 p-4">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
          <span className="px-2 py-0.5 rounded-full bg-accent-50 text-accent-600 font-medium">{item.category}</span>
          <span>{item.date}</span>
        </div>
        <h3 className="text-base font-medium text-foreground-950 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
          {item.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mt-2 flex-1">{item.summary}</p>
      </div>
    </Link>
  );
}